@if(_isLoading){
<app-loading-box></app-loading-box>
} @else if(notaDetalhe) {
<div class="title-container">
    <div>
        <h1 class="title-default">{{isDocumentoResumido ? 'Resumo da ' + nomeModeloDocumento : 'Detalhe da ' + nomeModeloDocumento}}</h1>
        <p class="welcome-message">
            <button mat-icon-button type="button" (click)="voltar()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            Veja aqui os detalhes deste documento fiscal
        </p>
    </div>
</div>

<section class="summary-section">
    <div class="summary-card">
        <span class="label">Valor total</span>
        <span class="value">{{ notaDetalhe.resumo.valorTotal | currency:'BRL' }}</span>
    </div>
    <div class="summary-card">
        <span class="label">Data de emissão</span>
        <span class="value">{{ notaDetalhe.resumo.dataEmissao | date:'dd/MM/yyyy' }}</span>
    </div>
    <div class="summary-card">
        <span class="label">Status</span>
        <span class="value status-valid"
            [ngClass]="{'status-valid':!_isCancelamento, 'status-cancelado':_isCancelamento}">{{
            obterDescricaoSituacaoDocumento() }}</span>
    </div>
</section>

<h2 class="section-title">Informações da Nota</h2>
<section class="info-grid">
    <div class="info-item wide">
        <span class="label">Chave</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.chave }}</span>
    </div>
    <div class="info-item">
        <span class="label">Número</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.numero }}</span>
    </div>
    <div class="info-item">
        <span class="label">Série</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.serie }}</span>
    </div>
    <div class="info-item">
        <span class="label">Data/Hora emissão</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.dataEmissaoCompleta | date:'dd/MM/yyyy HH:mm'
            }}</span>
    </div>
    <div class="info-item">
        <span class="label">Protocolo</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.protocolo }}</span>
    </div>
    <div class="info-item">
        <span class="label">Emitente</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.emitente }}</span>
    </div>
    <div class="info-item">
        <span class="label">Destinatário</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.destinatario }}</span>
    </div>
    <div class="info-item">
        <span class="label">CFOPs da Nota</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.cfopsDaNota }}</span>
    </div>
    <div class="info-item">
        <span class="label">Versão da {{ nomeModeloDocumento }}</span>
        <span class="value">{{ notaDetalhe.informacoesDocumento.versaoDaNFe }}</span>
    </div>
</section>

@if(notaDetalhe.tributosDeclarados){
<h2 class="section-title">Tributos declarados</h2>
<section class="info-grid tributos">
    <div class="info-item">
        <span class="label">Base de cálculo ICMS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.baseDeCalculoIcms | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">ICMS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.icms | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Base de cálculo IPI</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.baseDeCalculoIpi | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">IPI</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.ipi | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Base de cálculo ICMS ST</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.baseDeCalculoIcmsSt | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Substituição tributária</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.substituicaoTributaria | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Base de cálculo PIS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.baseDeCalculoPis | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Valor do PIS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.valorDoPis | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Base de cálculo COFINS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.baseDeCalculoCofins | currency:'BRL' }}</span>
    </div>
    <div class="info-item">
        <span class="label">Valor do COFINS</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.valorDoCofins | currency:'BRL' }}</span>
    </div>
    <div class="info-item total-tributos">
        <span class="label">Total de tributos declarados</span>
        <span class="value">{{ notaDetalhe.tributosDeclarados.totalDeTributosDeclarados | currency:'BRL' }}</span>
    </div>
</section>
}

@if(notaDetalhe.produtos){
<h2 class="section-title">Produtos</h2>

<table mat-table [dataSource]="dataSourceProdutos">
    <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef> Número </th>
        <td mat-cell *matCellDef="let element"> {{element.numero}} </td>
    </ng-container>
    <ng-container matColumnDef="codigo">
        <th mat-header-cell *matHeaderCellDef> Código </th>
        <td mat-cell *matCellDef="let element"> {{element.codigo}} </td>
    </ng-container>
    <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef> Descrição </th>
        <td mat-cell *matCellDef="let element"> {{element.descricao}} </td>
    </ng-container>
    <ng-container matColumnDef="valorTotal">
        <th mat-header-cell *matHeaderCellDef> Valor total </th>
        <td mat-cell *matCellDef="let element"> {{element.valorTotal | currency:'BRL'}} </td>
    </ng-container>
    <ng-container matColumnDef="cfop">
        <th mat-header-cell *matHeaderCellDef> CFOP </th>
        <td mat-cell *matCellDef="let element"> {{element.cfop | mask: '0.000' : { patterns: cfopMaskPatterns } }} </td>
    </ng-container>
    <ng-container matColumnDef="gtin">
        <th mat-header-cell *matHeaderCellDef> GTIN (EAN) </th>
        <td mat-cell *matCellDef="let element"> {{element.gtin}} </td>
    </ng-container>
    <ng-container matColumnDef="ncm">
        <th mat-header-cell *matHeaderCellDef> NCM </th>
        <td mat-cell *matCellDef="let element"> {{element.ncm | mask: '0000.00.00' }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsProdutos"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsProdutos;"></tr>
</table>
}


} @else {
<div class="title-container">
    <h1 class="title-default">Nota não encontrada</h1>
    <a routerLink="/notas-fiscais/painel-contador" mat-button class="btn-secondary" color="secundary">
        <mat-icon>arrow_back</mat-icon>
        Voltar para a listagem
    </a>
</div>
}
